/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import AddToCalendar from 'vue-add-to-calendar'
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var ReportForCheckinAPI = con.ReportForCheckinAPI;
var ADDCHECKINLOCATIONAPIURL = con.checkinLocationAddAPi;
var storageRef = con.storageRef;


export default {
    fetchGeoCheckinReports(context, field) {
        return new Promise((resolve, reject) => {
            const markers = []
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                "data": {
                    "DateTime": {
                        "from": field.from,
                        "to": field.to
                    },
                    "users": field.users && field.users.length > 0 ? [field.users] : []

                }
            }
            let headers = {
                "content-type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            axios.post(ReportForCheckinAPI, requestData, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        markers.push(response.data.result);
                    }
                }
                resolve({ status: 200, data: markers[0] })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })
        })
    },

    downloadGeoCheckinReports(context, field) {
        return new Promise((resolve, reject) => {
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                "data": {
                    "DateTime": {
                        "from": field.from,
                        "to": field.to
                    },
                    "users": field.users && field.users.length > 0 ? [field.users] : [],
                    "exportToExcel": true,
                }
            }
            let headers = {
                "content-type": "application/json",
                "Accept": "application/octet-stream",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            axios.post(ReportForCheckinAPI, requestData, { headers: headers, "responseType": 'blob', }).then((response) => {
                debugger;
                if (response.status == 200) {
                    context.dispatch('downloadCSV', response.data);
                }
                resolve({ status: 200 })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error);
            })
        })
    },

    downloadCSV(context, fileBytes) {
        const fileName = "workbook.xlsx";
        const url = window.URL.createObjectURL(new Blob([fileBytes], {
            type: 'application/vnd.ms-excel'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.target = "_blank";
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    },
}